module.exports = __webpack_public_path__ + "static/media/docs-unsigned.b0d9878c.svg";